import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import URL from '@/finsight/Router/urlConstants';

const getMarketOverviewAllSchema = () => ({
  '@type': 'Dataset',
  name: 'USOA ABS Bond Issuance Overview',
  alternateName: 'Asset-Backed Securities Bond Issuance Overview United States Region',
  description: 'View recent and historical ABS new issue pricing, volume and research across Auto, CLO, CMBS, Credit Card, Equipment, Esoteric, Student Loans and RMBS for the United States region.',
  keywords: ['asset-backed securities', 'bonds', 'United States region'],
  license: finsightWebUrl.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: finsightWebUrl.getUrl(URL.MARKET_OVERVIEW_ALL),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA ABS Top Sponsors',
      description: 'Trailing twelve months and recent USOA ABS Top Sponsors',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Trailing twelve months and recent USOA ABS New Issues',
      description: 'Recent USOA ABS New Issue',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewIGCSchema = () => ({
  '@type': 'Dataset',
  name: 'Investment Grade Corporate Bond Issuance Overview',
  alternateName: 'Investment Grade Corporate Bond Securities Issuance Overview United States Region',
  description: 'Recent and historical global investment grade corporate bond new issue pricing, volume and ratings tracker.',
  keywords: ['Investment Grade Corporate Bond securities', 'United States region'],
  license: finsightWebUrl.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: finsightWebUrl.getUrl(URL.MARKET_OVERVIEW_IGC),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA IGC Top Sponsors',
      description: 'Trailing twelve months and recent USOA IGC Top Sponsors',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA IGC New Issue',
      description: 'Trailing twelve months and recent USOA IGC New Issues',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewHYCSchema = () => ({
  '@type': 'Dataset',
  name: 'High Yield Corporate Bond Issuance Overview',
  alternateName: 'High Yield Corporate Bond Issuance Overview United States Region',
  description: 'Recent and historical global high yield corporate bond new issue pricing, volume and ratings tracker.',
  keywords: ['High Yield Corporate Bond securities', 'United States region'],
  license: finsightWebUrl.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: finsightWebUrl.getUrl(URL.MARKET_OVERVIEW_HYC),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA HYC Top Sponsors',
      description: 'Trailing twelve months and recent USOA HYC Top Sponsors',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA HYC New Issue',
      description: 'Trailing twelve months and recent USOA HYC New Issues',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewConsumerSchema = () => ({
  '@type': 'Dataset',
  name: 'USOA ABS (ex CLO, CMBS & RMBS) Issuance Overview',
  alternateName: 'Auto, Credit Card, Equipment, Esoteric and Student Loan Asset-Backed Securities United States Region',
  description: 'View recent and historical global ABS new issue pricing, volume and research across Auto, Credit Card, Equipment, Esoteric and Student Loan ABS..',
  keywords: ['asset-backed securities', 'Auto', 'Credit Card', 'Equipment', 'Esoteric', 'Student Loans', 'United States region'],
  license: finsightWebUrl.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: finsightWebUrl.getUrl(URL.MARKET_OVERVIEW_CONSUMER),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA ABS (ex CLO, CMBS & RMBS) Top Sponsors',
      description: 'Trailing twelve months and recent USOA ABS (ex CLO, CMBS & RMBS) Top Sponsors',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA ABS (ex CLO, CMBS & RMBS) New Issue',
      description: 'Trailing twelve months and recent USOA ABS (ex CLO, CMBS & RMBS) New Issues',
      license: finsightWebUrl.getTermsOfUseUrl(),
    },
  ],

});

const getProfileOverviewSchema = (pathname) => {
  if (pathname === URL.MARKET_OVERVIEW_ALL) {
    return getMarketOverviewAllSchema();
  }
  if (pathname === URL.MARKET_OVERVIEW_HYC) {
    return getMarketOverviewHYCSchema();
  }
  if (pathname === URL.MARKET_OVERVIEW_CONSUMER) {
    return getMarketOverviewConsumerSchema();
  }
  return getMarketOverviewIGCSchema();
};

export default getProfileOverviewSchema;
